import React from "react"
import cx from "classnames"
import { Link } from "gatsby"

export default ({ children, primary, to, ...props }) => {
  if (to) {
    return (
      <Link to={to} className={cx('button', { primary })} {...props}>
        {children}
      </Link>
    )
  }

  return (
    <button className={cx({ primary })} {...props}>
      {children}
    </button>
  )
}
